import {useEffect} from 'react';
import {Helmet} from 'react-helmet-async';
import {useAppSelector} from 'hooks';
import {selectScreen, startAuth} from 'auth/authSlice';
import {ScreenType} from 'auth/authApi';
import appStyle from 'App.module.css';
import Loader from 'components/Loader';
import ContactUs from 'components/ContactUs';
import FirstTimeAuth from 'modules/Login/FirstTimeAuth';
import cx from 'clsx';

import { TenantLogo } from 'components/TenantLogo/TenantLogo';

import { useIsDownSm } from 'hooks/useMediaQueries';

import { useTenantId } from 'hooks/useTenantId';


import { PoweredByEnnabl } from 'components/PoweredByEnnabl';

import VerificationCode from './VerificationCode';
import style from './Login.module.css';
import {useAppDispatch} from '../../store';


function renderForm(screenType: ScreenType) {
  if (screenType === 'ENTER_CODE') {
    return <VerificationCode />;
  } else {
    return <FirstTimeAuth />;
  }
}

const Login = () => {
  const isDownSm = useIsDownSm();
  const tenantId = useTenantId();
  const dispatch = useAppDispatch();
  const screen = useAppSelector(selectScreen);

  useEffect(() => {
    if (screen.screenType === 'ENTRY_SCREEN') {
      dispatch(startAuth(false));
    }
  }, [screen.screenType, dispatch]);

  return (
    <div className={appStyle.contentWrapper}>
    <Helmet>
      <title>Login - Ennabl</title>
    </Helmet>
    {tenantId && !isDownSm && <TenantLogo className={appStyle.tenantLogo} />}
    <div className={cx(appStyle.content, style.loginContainer)}>
      {['ENTRY_SCREEN', 'AUTHORIZED'].includes(screen.screenType) ? (
        <div className={appStyle.loaderContainer}>
          <Loader />
        </div>
      ) : (
        <>
          {renderForm(screen.screenType)}

          <ContactUs type='LOGIN' />

          {tenantId && isDownSm && <div className={appStyle.poweredBy}><PoweredByEnnabl /></div>}
        </>
      )}
    </div>
    </div>
  );
};

export default Login;
